import { Component, Input } from "@angular/core";

@Component({
  selector: "app-order-details-total",
  templateUrl: "./order-details-total.component.html",
  styleUrls: ["./order-details-total.component.scss"],
})
export class OrderDetailsTotalComponent {
  @Input("totalPrice") totalPrice = 0;
  @Input("shippingPrice") shippingPrice = 0;
  @Input("taxPrice") taxPrice = 0;
  @Input("formFee") formFee = 0;
  @Input("taxIncludes") taxIncludes: boolean;
  @Input("vaultSubsCost") vaultSubsCost = 0;
  @Input("showTaxPrice") showTaxPrice: boolean;
  @Input("showDeliveryPrice") showDeliveryPrice: boolean = true;
  @Input("showFormFee") showFormFee: boolean = false;
  @Input("showVaultSubsCost") showVaultSubsCost = false;


  constructor() {}
}
